module.exports = __webpack_public_path__ + "img/unusable.12b58c0b.svg";